<template>
  <div style="background-color: #F0F0F0;">
    <div>
      <el-drawer
        title="行业动态"
        v-if="drawer"
        v-infinite-scroll
        :visible.sync="drawer"
        :before-close="handleClose"
        size="60%">
        <div>
          <span class="newsTiltle">{{this.form.data.title}}</span>
          <hr noshade="noshade"/>
        </div>
        <div class="newsContent" v-html="form.data.detail">
        </div>
      </el-drawer>
    </div>
    <div class="container row" style="padding-top: 70px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-card :body-style="{ padding: '0px' }" shadow="hover"
                   style="border: none;border-radius: 0;margin-bottom: 20px;height: 400px;">
            <div class="add-content">
              <img class="add-icon" src="../../assets/createNewProject.png" @click="addNews"/>
              <el-button class="add-button" type="text"
                         @click="addNews">添加动态
              </el-button>
            </div>

          </el-card>
        </el-col>
        <el-col :span="8" v-for="item in tableData.data" :key="item.id">
           <el-card :body-style="{ padding: '0px' }" style="border: none;border-radius: 0;margin-bottom: 20px;height: 400px;" >
            <img :src="'/api'+ item.img" height="280" width="100%" @click="showDrawer(item.id)">
            <div style="padding: 14px;">
              <span>{{item.title}}</span>
              <div class="bottom clearfix" style="margin-top: 15px;">
                <span><time class="time">{{item.releaseAt}}</time></span>
                <span style="float: right;display: inline"><el-button type="text" class="button" icon="el-icon-edit"  @click="handleEdit(item.id)">编辑</el-button>
                <el-button type="text" class="button" icon="el-icon-delete" @click="handleDelete(item.id)">删除</el-button></span>
              </div>
            </div>
          </el-card>
        </el-col>

      </el-row>

    </div>


  </div>
</template>

<script>// eslint-disable-next-line import/no-cycle
import { getIndustryList, deleteIndustry, getIndustry } from '../../api/industry';

async function handleDelete(id) {
  this.drawer = false;
  this.$confirm('是否删除该条信息？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  })
    .then(async () => {
      const result = await deleteIndustry(id);
      if (result.code === 1200) {
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.form.data = {};
        this.getIndustries();
      }
    });
}

function handleEdit(id) {
  this.$router.push({
    path: '/industryEdit',
    query: {
      id,
    },
  });
}

function handleClose() {
  this.drawer = false;
}

async function showDrawer(id) {
  this.drawer = true;
  const result = await getIndustry(id);
  console.log(result);
  if (result.code === 1200) {
    this.form.data = result.data.industry;
  }
}


export default {
  name: 'newsList',
  data() {
    return {
      direction: 'rtl',
      drawer: false,
      tableData: {
        data: [],
      },
      form: {
        data: {
          id: '',
          title: '',
          detail: '',
          img: '',
        },
      },

    };
  },
  methods: {
    handleDelete,
    handleEdit,
    handleClose,
    showDrawer,
    async getIndustries() {
      const result = await getIndustryList();
      if (result.code === 1200) {
        this.tableData.data = result.data.industry;
      }
    },
    addNews() {
      this.$router.push({
        path: '/industryEdit',
        query: {
          id: '',
        },
      });
    },
  },
  async created() {
    this.getIndustries();
  },
  components: {
  },
};
</script>

<style scoped>

  .add-content{
    text-align: center;
    margin-top: 150px;
  }
  .add-content img {
    display: block;
  }
  .add-icon {
    width: 62px;
    height: 62px;
    object-fit: cover;
    margin: 0 auto;
  }

  .add-button {
    height: 20px;
    width: 100px;
    color: #7F8289;
    font-size: 18px;
    cursor: pointer;
  }
  .add-button:hover{
    color: #7F8289
  }
  .container {
    padding: 0;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .newsTiltle {
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    color: #101010;
    letter-spacing: 1.75px;
    padding-left: 40px;
  }

  .newsContent {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    letter-spacing: 1px;
    line-height: 31px;
    text-align: left;
    padding-left: 39px;
  }
</style>
<style>
  .el-drawer__header {
    font-size: 20px;
    text-align: center;
  }
  .el-drawer__body{
    overflow-y: auto;
  }
</style>
